export default __webpack_public_path__ + "static/media/IQ.36601f98.svg";